module.exports = __webpack_public_path__ + "img/plus_sign_custom2.93055df7.png";